import axios from 'axios';

export const MenuApi = {
  loadMenuList: filter =>
    axios.get(`/api/public/menu/get_list_of_menu?filter=${filter}`),
  loadAgeGroups: (id) => axios.get(`/api/public/info/all_groups_by_sp_id/${id}`),
  addMenu: (params) => axios.post(`/api/public/menu/multiple`, params),
  updateMenu: (params) => axios.put(`/api/public/menu`, params),



};